import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom LMS & School Management Software | RojrzTech',
    description: 'Transform education with custom Learning Management Systems (LMS), online student portals, live virtual classrooms, and school administration tools.',
  },
  hero: {
    badge: 'EDUCATION & E-LEARNING',
    slides: [
      {
        heading: { pre: 'Next-Gen', gold: 'Learning Management', post: 'Systems' },
        subheading: 'We build custom school portals, Learning Management Systems (LMS), live virtual classroom tools, and student administrative dashboards.',
        pills: ['Custom LMS', 'Student Portals', 'Quiz Systems', 'Grading Engine', 'Live Classrooms'],
        image: '/education.jpeg',
      },
      {
        heading: { pre: 'Interactive Student &', gold: 'Teacher Dashboards' },
        subheading: 'Power your school or coaching institute with custom student progress profiles, assignment submission portals, and automatic grade tracking systems.',
        pills: ['Assignment Upload', 'Grading Dashboard', 'Attendance log', 'Parent Reports', 'Calendar Sync'],
        image: '/education1.jpeg',
      },
      {
        heading: { pre: 'Secure Video Classes &', gold: 'E-Learning Vaults' },
        subheading: 'Provide digital-first learning. Securely stream lecture recordings, distribute syllabus materials, and host interactive quizzes.',
        pills: ['Lecture Player', 'PDF Library', 'Interactive Quizzes', 'Certificate Auto', 'Secure Logins'],
        image: '/education.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'STUDENT PORTAL',
    phoneSubtitle: 'Access online lectures, download homework, and check grades.',
    tags: [
      { title: 'Student Portal Systems', desc: 'Secure portals where students view syllabus documents and check report cards.' },
      { title: 'Local Search Lead Capture', desc: 'Rank top-3 for educational queries like "tutoring classes" or "LMS software".' },
      { title: 'Interactive Quiz Engines', desc: 'Let teachers configure automated multiple-choice tests and exam modules.' },
      { title: 'Assignment Upload Tools', desc: 'Allow students to securely upload homework and project drafts.' },
      { title: 'Tuition Payment Portals', desc: 'Process student tuition fees, exam fees, and resource subscriptions.' },
      { title: 'Teacher Control Panel', desc: 'Give teachers tools to log attendance, input grades, and upload worksheets.' },
    ],
  },
  videoSection: {
    title: 'School LMS Platform Demo',
    subtitle: 'See how our administrative dashboard registers students, tracks attendance, and updates gradebooks.',
    frameLabel: 'SCHOOL ADMINISTRATION DASHBOARD',
  },
  cards: {
    title: 'Custom Engineering for Schools & E-Learning',
    subtitle: 'RojrzTech builds secure, scalable Learning Management Systems designed to handle thousands of active students and teachers.',
    items: [
      {
        icon: '🎓',
        title: 'Custom LMS Development',
        description: 'Provide your institute with a bespoke Learning Management System containing custom student, teacher, and parent logins.',
      },
      {
        icon: '📊',
        title: 'Student Progress Portals',
        description: 'Empower parents and students to monitor grade averages, track daily attendance, and review teacher feedback reports.',
      },
      {
        icon: '⚡',
        title: 'Digital Classrooms',
        description: 'Distribute study guides, upload lecture recordings, and integrate interactive multiple-choice quiz modules.',
      },
    ],
  },
  features: {
    title: 'Advanced E-Learning Software Features',
    subtitle: 'Everything your school or training center needs to run classes, manage grades, and process payments.',
    items: [
      'Interactive Video Player',
      'Student Assignment Upload',
      'Tuition Billing Gateway',
      'Automated Quiz Scoring',
      'Parent Report Cards',
      'Teacher Gradebooks',
      'Course File Library',
      'Institution Calendar Sync',
      'Live Video Lecture Sync',
      'Class Attendance Logger',
      'Auto Course Certificates',
      'Student Group Chats',
    ],
  },
};

const Education = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Education;
